class DefaultTableData
{
  static default_td_data_row = {
    lecture_seq: "",
    lecture_name:"",
    name:"",
    start_time_m: 0,
    end_time_m: 0,
    time_str: "00:00~00:00",
    start_h: "",
    start_m: "",
    end_h: "",
    end_m: "",
    range_start_time_m:0,
    range_end_time_m:0,
    range_time_str:"00:00~00:00",
    room_seq: "",
    room_name: "",
    teacher_seq: "",
    teacher_name: "",
    day_num: "",
    stu_union_time_info:{},
  };
}
export default DefaultTableData;